import { Schema } from "prosemirror-model"

const pDOM = ["p", 0]
const brDOM = ["br"]

const emDOM = ["em", 0]
const strikeDOM = ["strike", 0]
const underlineDOM = ["u", 0]

const strongDOM = ["strong", 0]
const codeDOM = ["code", 0]
const blockquoteDOM = ["blockquote", 0]

const nodes = {
    doc: {
        content: "block+"
    },
    paragraph: {
        content: "inline*",
        group: "block",
        parseDOM: [{ tag: "p" }],
        toDOM() {
            return pDOM
        }
    },
    text: {
        group: "inline"
    },
    hard_break: {
        inline: true,
        group: "inline",
        selectable: false,
        parseDOM: [{ tag: "br" }],
        toDOM() {
            return brDOM
        }
    },
    blockquote: {
        content: "block+",
        group: "block",
        defining: true,
        parseDOM: [{ tag: "blockquote" }],
        toDOM() {
            return blockquoteDOM
        }
    },
    heading: {
        attrs: { level: { default: 1, validate: "number" } },
        content: "inline*",
        group: "block",
        defining: true,
        parseDOM: [
            { tag: "h1", attrs: { level: 1 } },
            { tag: "h2", attrs: { level: 2 } },
            { tag: "h3", attrs: { level: 3 } },
            { tag: "h4", attrs: { level: 4 } },
            { tag: "h5", attrs: { level: 5 } },
            { tag: "h6", attrs: { level: 6 } }
        ],
        toDOM(node) {
            return ["h" + node.attrs.level, 0]
        }
    }
}

const marks = {
    link: {
        attrs: {
            href: { validate: "string" },
            title: { default: null, validate: "string|null" }
        },
        inclusive: false,
        parseDOM: [
            {
                tag: "a[href]",
                getAttrs(dom) {
                    return { href: dom.getAttribute("href"), title: dom.getAttribute("title") }
                }
            }
        ],
        toDOM(node) {
            let { href, title } = node.attrs
            return ["a", { href, title }, 0]
        }
    },
    em: {
        parseDOM: [
            { tag: "i" },
            { tag: "em" },
            { style: "font-style=italic" },
            { style: "font-style=normal", clearMark: m => m.type.name == "em" }
        ],
        toDOM() {
            return emDOM
        }
    },
    strike: {
        parseDOM: [
            { tag: "strike" },
            { style: "text-decoration=strike-through" },
            { style: "text-decoration=normal", clearMark: m => m.type.name == "strike" }
        ],
        toDOM() {
            return strikeDOM
        }
    },
    underline: {
        parseDOM: [
            { tag: "u" },
            { style: "text-decoration=underline" },
            { style: "text-decoration=normal", clearMark: m => m.type.name == "u" }
        ],
        toDOM() {
            return underlineDOM
        }
    },
    strong: {
        parseDOM: [
            { tag: "strong" },
            // This works around a Google Docs misbehavior where
            // pasted content will be inexplicably wrapped in `<b>`
            // tags with a font-weight normal.
            { tag: "b", getAttrs: node => node.style.fontWeight != "normal" && null },
            { style: "font-weight=400", clearMark: m => m.type.name == "strong" },
            { style: "font-weight", getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null }
        ],
        toDOM() {
            return strongDOM
        }
    },
    /**
     Code font mark. Represented as a `<code>` element.
     */
    code: {
        parseDOM: [{ tag: "code" }],
        toDOM() {
            return codeDOM
        }
    }
}

export default new Schema({
    nodes,
    marks
})
